<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-select
          v-model="location_type"
          style="width:200px"
          class="handle-select mr10"
          @change="selectHandle"
        >
          <el-option
            v-for="(child, index) in location_types"
            :key="index"
            :label="child.label"
            :value="child.value"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add"
          @click="addEdit"
          >新增</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="封面" align="center" width="200">
          <template slot-scope="scope">
            <el-image
              class="table-td-thumb"
              :src="scope.row.img_url"
              :preview-src-list="[scope.row.img_url]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="类型1" align="center">
          <template slot-scope="scope">{{
            bannerType(scope.row.type)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="extra_info"
          label="额外信息"
          align="center"
        ></el-table-column>
        <el-table-column label="启用状态" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.enable">已启用</el-tag>
            <el-tag type="danger" v-else>未启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="日期" align="center">
          <template slot-scope="scope">{{
            formatDate(scope.row.created_at)
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.enable"
              type="text"
              icon="el-icon-edit"
              @click="enableEdit(scope.row)"
              >不启用</el-button
            >
            <el-button
              v-else
              type="text"
              icon="el-icon-edit"
              @click="enableEdit(scope.row)"
              >启用</el-button
            >
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <addconfig :dataArr="form" @putsuccess="resetData"></addconfig>
    </el-dialog>
    <el-dialog
      :visible.sync="isshowchange"
      width="50%"
      :close-on-click-modal="false"
    >
      <changeconfig
        :changedataArr="changedataArr"
        @putsuccess="changeresetData"
      ></changeconfig>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/hemeraApiConfig";
import http2 from "../../../api/uploadApiConfig";
import addconfig from "./banner_config";
import changeconfig from "./banner_change";
export default {
  name: "Bannermanage",
  data() {
    return {
      location_types: [
        { label: "家庭中医馆首页", value: 1 },
        { label: "家庭中医馆发现页", value: 2 },
        { label: "中医智库工作室首页", value: 3 },
        { label: "中医智库活动中心", value: 4 },
        { label: "中医智库首页（APP和H5）", value: 5 },
        { label: "中医智库PC", value: 6 },
      ],
      location_type: 1,
      banners_type: [],
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      loading: false,
      imageUrl: "",
      multipleSelection: [],
      delList: [],
      editVisible: false,
      is_add: false,
      uploading: false,
      form: {},
      changedataArr: {},
      isshowchange: false,
      submit_obj: {},
      rules: {
        Code: [{ required: true, message: "请填写code", trigger: "blur" }],
        SignName: [
          { required: true, message: "请填写sign_name", trigger: "blur" },
        ],
        AppKey: [{ required: true, message: "请填写app_key", trigger: "blur" }],
        AppSecret: [
          { required: true, message: "请填写app_secret", trigger: "blur" },
        ],
        TemplateCode: [
          { required: true, message: "请填写模板格式", trigger: "blur" },
        ],
        AllowCount: [
          { required: true, message: "请填写允许次数", trigger: "blur" },
        ],
      },
      idx: -1,
      id: -1,
    };
  },
  components: {
    addconfig,
    changeconfig,
  },
  created() {
    this.getData();
    this.getbanner_type();
    // this.addEdit();
    this.form = {
      enable: 0,
      img_path: "",
      extra_info: "",
      type: 1,
      location_type: this.location_type,
    };
  },
  methods: {
    getbanner_type() {
      let that = this;
      let url = "admin/banners_type?location_type=" + this.location_type;
      http.get(url).then(function(res) {
        console.log(res);
        that.banners_type = res.data.data;
      });
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    bannerType(id) {
      var item = _.filter(this.banners_type, function(selector) {
        return selector.id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      params["location_type"] = that.location_type;
      http.get("admin/banners", { params: params }).then(function(res) {
        console.log(res);
        that.tableData = res.data.data;
        that.currentPage = res.data.data.current_page;
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    //选择
    selectHandle(event) {
      console.log(event,"event");
      this.location_type = event;
      this.currentPage = 1;
      this.getData();
      this.getbanner_type();
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", "common/banner");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.imageUrl = "common/banner/" + filename;
            that.form.img_path = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //启用操作
    enableEdit(row) {
      let that = this;
      let params = {
        type: row.type,
        extra_info: row.extra_info,
        img_path: row.img_path,
      };
      if (row.enable) {
        params["enable"] = 0;
        that
          .$confirm("是否关闭启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/banners/" + row.id, params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("关闭成功");
                that.getData();
              }
            });
          })
          .catch(() => {});
      } else {
        params["enable"] = 1;
        that
          .$confirm("是否启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/banners/" + row.id, params).then(function(res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("启用成功");
                that.getData();
              }
            });
          })
          .catch(() => {});
      }
    },
    // 删除操作
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("admin/banners/" + row.id).then(function(res) {
            // console.log(res);
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            }
          });
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onInput() {
      this.$forceUpdate();
    },
    // 编辑操作
    handleEdit(item) {
      this.isshowchange = true;
      this.changedataArr = {
        id: item.id,
        img_path: item.img_path,
        type: item.type,
        extra_info: item.extra_info,
        enable: item.enable,
        img_url: item.img_url,
        location_type: this.location_type,
      };
      console.log(item);
      console.log(this.changedataArr);
    },
    resetData(data) {
      // console.log(data)
      if (data == 1) {
        this.getData();
        // this.loading = true;
        this.editVisible = false;
      }
    },
    changeresetData(data) {
      // console.log(data)
      if (data == 1) {
        this.getData();
        this.isshowchange = false;
      }
    },
    //新增操作
    addEdit() {
      this.form = {
        enable: 0,
        img_path: "",
        extra_info: "",
        type: 1,
        location_type: this.location_type,
      };
      console.log(this.location_type,"location_typeAdd");
      this.is_add = true;
      this.editVisible = true;
    },
    // 保存编辑
    saveEdit(formName) {
      let that = this;
      console.log(that.location_type, "that.location_type");
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            enable: that.form.enable,
            img_path: that.imageUrl,
            extra_info: that.form.extra_info,
            location_type: that.location_type,
            type: that.form.type,
          };
          console.log(params, "pp");
          if (that.is_add) {
            http.post("admin/banners", params).then(function (res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success(`新增成功`);
                that.getData();
              }
            });
          } else {
            http
              .put("admin/banners/" + that.form.id, params)
              .then(function (res) {
                // console.log(res);
                if (res.data.status_code == 200) {
                  that.$message.success(`修改成功`);
                  that.getData();
                }
              });
          }
          // console.log(params);

          that.editVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
.avatar {
  height: 178px;
  display: block;
  max-width: 100%;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
